import { connect } from 'react-redux';
import { getMaterialByArticleNumberThunk } from '@/store/actions/cmme';
import LoadCFWByArticleNumberModal from './LoadCFWByArticleNumberModal.jsx';

const mapDispatchToProps = dispatch => ({
  getMaterialByArticleNumberThunk: (productId) => dispatch(getMaterialByArticleNumberThunk(productId)),
});

export default connect(null, mapDispatchToProps)(LoadCFWByArticleNumberModal);
